<template>
  <el-dialog
    :visible.sync="visible"
    title="知识库文章"
    width="820px"
    top="6vh"
    custom-class="doc-modal-dialog"
    @close="$emit('close')"
  >
    <div v-loading="loading" class="doc-wrap">
      <template v-if="!loading">
        <h2 class="doc-title">{{ doc.title || '（无标题）' }}</h2>
        <div v-if="tagList.length" class="doc-tags">
          <span v-for="t in tagList" :key="t" class="doc-tag">{{ t }}</span>
        </div>
        <p v-else class="doc-tags-empty muted">暂无标签</p>
        <div class="doc-divider" />
        <div v-if="contentHtml" class="doc-content markdown-body" v-html="contentHtml" />
        <p v-else class="doc-empty muted">暂无正文</p>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import { renderMarkdown } from '@/utils/markdown'

export default {
  name: 'DocModal',
  props: {
    show: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    doc: { type: Object, default: () => ({}) }
  },
  computed: {
    visible: {
      get() { return this.show },
      set(v) { if (!v) this.$emit('close') }
    },
    contentHtml() {
      return renderMarkdown(this.doc.content || '')
    },
    tagList() {
      const t = this.doc.tags
      if (!t) return []
      if (Array.isArray(t)) return t.map(String).map(s => s.trim()).filter(Boolean)
      return String(t).split(/[,，]/).map(s => s.trim()).filter(Boolean)
    }
  }
}
</script>

<style lang="scss" scoped>
.doc-wrap {
  min-height: 120px;
  max-height: 72vh;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 4px 2px 8px;
}

.doc-title {
  margin: 0 0 14px;
  font-size: 20px;
  font-weight: 700;
  color: #0F2942;
  line-height: 1.45;
}

.doc-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 4px;
}

.doc-tag {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 14px;
  font-size: 13px;
  background: #E0F2FE;
  color: #0369A1;
  font-weight: 500;
}

.doc-tags-empty {
  margin: 0 0 4px;
  font-size: 13px;
}

.doc-divider {
  height: 1px;
  background: $line;
  margin: 16px 0 18px;
}

.doc-empty {
  font-size: 14px;
  padding: 24px 0;
  text-align: center;
}

.doc-content {
  font-size: 15px;
  line-height: 1.85;
  color: #1E293B;
  max-width: 100%;
  overflow-x: auto;
}
</style>

<style lang="scss">
.doc-modal-dialog {
  max-width: calc(100vw - 32px);

  .el-dialog__body {
    padding: 16px 24px 24px;
    overflow: hidden;
  }

  .el-dialog__header {
    padding: 18px 24px 12px;
    border-bottom: 1px solid #E2E8F0;

    .el-dialog__title {
      font-size: 16px;
      font-weight: 600;
      color: #0F2942;
    }
  }
}

@media (max-width: 640px) {
  .doc-modal-dialog {
    width: calc(100vw - 24px) !important;
    margin-top: 4vh !important;
  }
}
</style>
